export enum SessionFilters {
  GameDate = 'gameDate',
  Venue = 'venue',
  Field = 'field',
  HomeTeam = 'homeTeam',
  AwayTeam = 'awayTeam',
  Level = 'level',
  League = 'league',
  GameReference = 'gameReference',
}
